<template>
  <div :class="classes.eventRowWrapper">
    <ParlayButton
      :marketId="marketId"
      :eventId="eventId"
      :optionId="orderedOptionIds[0]"
      :isLeft="true"
      :class="classes.flexCenter"
      :competitor="competitors[0]"
      homeOrAwayTeam="home"
    />
    <ParlayButton
      v-if="isWdw"
      :marketId="marketId"
      :eventId="eventId"
      :optionId="orderedOptionIds[1]"
      :isDraw="true"
      :class="[classes.flexCenter, classes.vs, layoutClass]"
      :disableBadges="true"
    />
    <TeamVersusIcon
      v-else
      :eventId="eventId"
      v-bind="$attrs"
      :class="[classes.flexCenter, classes.vs, classes.vsText]"
      :maxHeight="'25px'"
      :maxWidth="'25px'"
    />

    <ParlayButton
      :marketId="marketId"
      :eventId="eventId"
      :optionId="orderedOptionIds[orderedOptionIds.length - 1]"
      :isLeft="false"
      :class="classes.flexCenter"
      :competitor="competitors[1]"
      homeOrAwayTeam="away"
    />
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { computed, ComputedRef, defineComponent, PropType } from "vue";
import {
  injectBrand,
  BrandContext
} from "@fresh8/ad-data-composition/src/brand";

import {
  injectTemplateSize,
  LARGE_RESPONSIVE
} from "@fresh8/ad-data-composition/src/useTemplateSize";
import TeamVersusIcon from "../../../TeamVersusIcon.vue";
import ParlayButton from "../ParlayButton.vue";
import {
  composeEventCompetitors,
  injectBetData
} from "@fresh8/ad-data-composition/src/betData";
import { FULL_TIME_RESULT } from "../../../../constants/market-types";
import { Market, SportCompetitor } from "@fresh8/types/src/betData";
import { provideTeamColors } from "../../../../lib/teamBranding";

const useStyles = createUseStyles({
  eventRowWrapper: {
    display: "flex",
    flex: "1",
    padding: "4px 0",
    boxSizing: "border-box",
    alignItems: "center",
    whiteSpace: "nowrap",
    justifyContent: "space-between",

    "&:first-child": {
      paddingTop: "0"
    },

    "&:last-child": {
      paddingBottom: "0"
    }
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxHeight: "32px",
    boxSizing: "border-box",
    height: "100%",

    ["&$vs, &$vsText"]: {
      flex: "0 0 100%",
      maxWidth: "44px",
      minWidth: "44px"
    }
  },
  vs: {
    margin: "0 8px",

    [`&.${LARGE_RESPONSIVE.name}`]: {
      minWidth: "20%"
    }
  },
  vsText: {
    fill: "#6F7496"
  }
});

export default defineComponent({
  name: "MPUParlayEventRow",
  components: {
    TeamVersusIcon,
    ParlayButton
  },
  props: {
    eventId: { type: String, required: true },
    marketId: { type: String, required: true },
    orderedOptionIds: { type: Array as PropType<string[]>, required: true }
  },
  setup(props) {
    const template = injectTemplateSize();
    const classes = useStyles();
    const { marketBranding, adTemplate } =
      injectBrand() || ({} as BrandContext);
    const betData = injectBetData();
    const competitors = composeEventCompetitors(props.eventId) as ComputedRef<
      SportCompetitor[]
    >;

    const isWdw = computed(() => {
      return (
        (betData?.markets as ComputedRef<Record<string, Market>>).value[
          props.marketId
        ].marketType === FULL_TIME_RESULT
      );
    });

    const useTeamIcons = computed(
      () =>
        adTemplate.value?.team.useTeamBranding &&
        adTemplate.value?.team.useAdditionalBrandingOptions
    );

    provideTeamColors(props.eventId);

    return {
      useTeamIcons,
      classes,
      marketBranding,
      layoutClass: computed(() => template?.size.value.name),
      isWdw,
      competitors
    };
  }
});
</script>
